import { createSafeContext } from '@libs/ui/ds/lib/internals'

export type MenuGroupContext = {}

export const [MenuGroupProvider, useMenuGroupContext] =
  createSafeContext<MenuGroupContext>({
    context: 'MenuGroup'
  })
